module.exports = __webpack_public_path__ + "svg/illustration-landlord-eviction.d2b0ce2.svg";